"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
const UserClient_1 = require("./UserClient");
class UserService {
    constructor(authService) {
        this.authService = authService;
        this.userClient = new UserClient_1.UserClient(this.authService);
    }
    async getCurrentUserEmail() {
        const userData = await this.userClient.getCurrentUser();
        return userData.email ? userData.email : '';
    }
    async getCurrentUserId() {
        const userData = await this.userClient.getCurrentUser();
        return userData.sub ? userData.sub : '';
    }
}
exports.UserService = UserService;
//# sourceMappingURL=UserService.js.map